import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';  
import { EnvironmentService } from '../environment.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
	isButtonVisible: boolean = true;
	pwdBlock: boolean = false;
	closeButton: boolean = false;
	showModal: boolean = false;
	urlPath: string;
	resetPwdKey: any = '';
	newPassword: string;
	confirmPassword: string;
	userLogged: any;
	showHeader: boolean = false;
	constructor(private envServiceProvider: EnvironmentService,private route: ActivatedRoute, private toastr: ToastrService, private loginService: LoginService, private router: Router, public translate: TranslateService) { }

 
	ngOnInit() {
		this.envServiceProvider.currentMessage.subscribe(message => this.resetPwdKey = message);

		// if (this.route.snapshot.url && this.route.snapshot.url.length > 0) {
		//   this.urlPath = this.route.snapshot.url[0].path;
		// }
		// if(this.route.snapshot.queryParams) {
		// 	this.resetPwdKey = this.route.snapshot.queryParams;
		// }
		// if(this.urlPath) {
		if (this.resetPwdKey !== ''&& this.resetPwdKey !== undefined && this.resetPwdKey!== null && (typeof(this.resetPwdKey) === "string")) {
			this.show();
		}
		this.userLogged = localStorage.getItem('user');
		if(this.userLogged){
			this.showHeader = true;
		} else {
			this.showHeader = false;
		}
		let userData = JSON.parse(localStorage.getItem("user"));
	   
		if(userData && userData.email == "admin@uib.ai"){
             this.router.navigate(['/overview']);
         }
		
	}
	
	login() {
		this.pwdBlock = true;
		this.closeButton = true;
		this.hide();
	}

	closeEvent(event: any){
			this.pwdBlock = false;
	}

  	show(){
	  this.showModal = true;
	}

	hide() {
	  this.showModal = false;
	}

	logout(status:boolean){
    	this.showHeader = status;
	}

	resetingPassword() {
		if(this.newPassword == '' || this.newPassword == undefined || 
		this.confirmPassword == '' || this.confirmPassword == undefined) {
			//this.toastr.error('','Please Enter Password');
			this.translate.get('Layout.EnterPassword').subscribe((res: string) => {
				this.toastr.error(res)
			})
		}else if(this.newPassword != this.confirmPassword) {
			//this.toastr.error('','Password mismatch');
			this.translate.get('Layout.PasswordMismatch').subscribe((res: string) => {
				this.toastr.error(res)
			})
		}else {
			const args = {
				key: this.resetPwdKey,
				newPassword: this.newPassword
			};
			this.loginService.resetPassword(args).subscribe(data => {
				//console.log("---resetingPassword---",data);				 
				 if(data && data.status == false) {
					 //this.toastr.error('', data.info);
					 if(data.info =='password_missing'){
						this.translate.get('Layout.EnterPassword').subscribe((res: string) => {
							this.toastr.error(res);
					   })
					} else if(data.info =='resetkey_missing' || data.info =='no_reset_key'){
						this.translate.get('Layout.ResetKeyMissing').subscribe((res: string) => {
							this.toastr.error(res);
					   })
					} else if(data.info =='key_mismatch' || data.info =='reset_key_mismatch'){
						this.translate.get('Login.ResetKeyMismatch').subscribe((res: string) => {
							this.toastr.error(res);
					   })
					} else if(data.info =='email_address_missing'){
						this.translate.get('Login.EmailMissing').subscribe((res: string) => {
							this.toastr.error(res);
					   })
					} else{
						this.toastr.error('', data.info);
					   }
					 this.hide();
					 this.router.navigate(['/']); 
				}else {
					this.translate.get('Common.Success').subscribe((res: string) => {
						this.toastr.success(res)
					})
					//this.toastr.success('', 'Success');
					this.hide();
					this.router.navigate(['/']);
				}				
			});
		}
	}
}
